import { notification } from './notification'

const request = {
  csrfToken: '',

  initializeCsrfToken() {
    const csrfElement = document.querySelector('[name=csrfmiddlewaretoken]')
    this.csrfToken = csrfElement ? csrfElement.value : ''
  },

  async request(url, method, data = null, headers = {}, signal = null) {
    notification.loading.value++

    // If data is FormData, don't set Content-Type - browser will set it with boundary
    const isFormData = data instanceof FormData

    const options = {
      method,
      headers: {
        'X-CSRFToken': this.csrfToken,
        ...headers,
      },
      ...(signal ? { signal } : {}),
    }

    // Only set Content-Type if not FormData and not already set in headers
    if (!isFormData && !headers['Content-Type']) {
      options.headers['Content-Type'] = 'application/json'
    }

    if (
      data &&
      !isFormData &&
      options.headers['Content-Type'] === 'application/json'
    ) {
      options.body = JSON.stringify(data)
    } else {
      options.body = data
    }

    try {
      const response = await fetch(url, options)

      if (!response.ok) {
        let errorData = null

        try {
          errorData = await response.json()
          // console.log('------errorData', errorData)
        } catch (e) {
          // console.log('------e', e)
          errorData = response.statusText || 'Eroare de server'
        }

        const error = new Error('Eroare de server')
        error.status = response.status
        error.data = errorData
        throw error
      }

      if ([204, 205, 304, 100, 101, 102, 103].includes(response.status)) {
        return null
      }

      return response.json()
    } catch (error) {
      if (error.name === 'AbortError') {
        throw error
      }

      const detail =
        error.data?.message ||
        (Array.isArray(error.data?.detail)
          ? error.data.detail[0]
          : error.data?.detail) ||
        error.message

      notification.toast.add({
        severity: 'error',
        summary: 'Eroare',
        detail,
        life: 5000,
      })

      // console.error('API request error:', error)
      throw error
    } finally {
      notification.loading.value--
    }
  },

  get(url, data = {}, headers = {}, signal = null) {
    const filteredData = Object.fromEntries(
      Object.entries(data).filter(([key, value]) => value != null),
    )
    const queryString = new URLSearchParams(filteredData).toString()
    const urlWithParams = queryString ? `${url}?${queryString}` : url

    return this.request(urlWithParams, 'GET', null, headers, signal)
  },

  post(url, data, headers = {}) {
    return this.request(url, 'POST', data, headers)
  },

  put(url, data, headers = {}) {
    return this.request(url, 'PUT', data, headers)
  },

  patch(url, data, headers = {}) {
    return this.request(url, 'PATCH', data, headers)
  },

  delete(url, headers = {}) {
    return this.request(url, 'DELETE', null, headers)
  },
}

document.addEventListener('DOMContentLoaded', () =>
  request.initializeCsrfToken(),
)

export default request
